var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40.719,
    viewBox: "0 0 42 41.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(-742 -348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_459",
    "data-name": "Path 459",
    transform: "translate(742 350.83)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H38.889V38.889H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.999996185302734 3.999996185302734 L 3.999996185302734 34.88888549804688 L 34.88888549804688 34.88888549804688 L 34.88888549804688 3.999996185302734 L 3.999996185302734 3.999996185302734 M -3.814697265625e-06 -3.814697265625e-06 L 38.88888549804688 -3.814697265625e-06 L 38.88888549804688 38.88888549804688 L -3.814697265625e-06 38.88888549804688 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 20,
    height: 20,
    transform: "translate(764 348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    "data-name": "Rectangle 1438",
    width: 10,
    height: 10,
    transform: "translate(749 373)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.4aac5efeff022b62332d020757f2609d.svg";
export { ForwardRef as ReactComponent };